/**
 * UI控件库 
 * @module UI
 */
;(function (ui) {
    "use strict";
    /**
     * <h3>下拉菜单</h3>
     * <a href="../../ui_controls/bui.dropdown.html" target="_blank">demo</a>
     * <p>可以选中不修改值,一般在点击的时候触发</p>
     * <h5>方法</h5>
     * {{#crossLink "bui.dropdown/option"}}{{/crossLink}}: 获取设置参数 <br>
     * {{#crossLink "bui.dropdown/widget"}}{{/crossLink}}: 获取依赖控件 <br>
     * {{#crossLink "bui.dropdown/value"}}{{/crossLink}}: 不传参则获取,传参则设置 <br>
     * {{#crossLink "bui.dropdown/text"}}{{/crossLink}}: 不传参则获取文本,传参则设置文本 <br>
     * {{#crossLink "bui.dropdown/hide"}}{{/crossLink}}: 隐藏二级菜单 <br>
     * {{#crossLink "bui.dropdown/show"}}{{/crossLink}}: 显示二级菜单 <br>
     * {{#crossLink "bui.dropdown/hideAll"}}{{/crossLink}}: 隐藏所有二级菜单 <br>
     *  @namespace bui
     *  @class dropdown
     *  @constructor 
     *  @param {object} option  
     *  @param {string} option.id [控件id]  
     *  @param {string} [option.handle] [一级菜单的按钮]  
     *  @param {string} [option.handleChildren] [文本值的位置]  
     *  @param {string} [option.target] [二级菜单,默认是按钮的下一个]   
     *  @param {string} [option.targetHandle] [二级菜单的按钮,点击触发callback]   
     *  @param {number} [option.width] [ 二级菜单的宽度,一级自适应宽度 ]  
     *  @param {boolean} [option.showArrow] [ 是否显示箭头 ]  
     *  @param {boolean} [option.showActive] [ 是否显示选中的高亮效果 ]  
     *  @param {boolean} [option.relative] [ true相对于屏幕两边 false相对于父层 ]  
     *  @param {boolean} [option.change] [ true修改文本, false只是做选择操作,可以通过change属性定义 ]  
     *  @param {string} [option.position] [ 显示的位置 bottom | top | left | right 也可以通过position属性设置,权限会更高 ]  
     *  @param {function} [option.callback] [ 点击按钮的回调,第一个参数是自己的引用 ]  
     *  @example
     * 
     *   html:
     *
            <div id="dropdown" class="bui-dropdown">
                <div class="bui-btn">
                    下拉菜单
                </div>
                <ul class="bui-dropdown-menu">
                    <li class="bui-btn bui-box" value="11">
                        <div class="span1">
                            列表1
                        </div>
                        <i class="icon-listright"></i>
                    </li>
                </ul>
            </div>
     *      
     *   js: 
     *   
            // 初始化
            var uiDropdown = bui.dropdown({
                id: "#dropdown"
            })
     *
     *
     */
    ui.dropdown = function(option){
        
        //默认配置
        var config = {
            id: "",             
            handle: ".bui-btn", 
            handleChildren: ".span1",
            target: "",
            targetHandle:  ".bui-btn", 
            position: "bottom",
            showArrow: false,
            showActive: false,
            width: 0,           
            relative: true,     
            change: true,       
            callback: null
        }

        //方法
        var module = {
            value: value,
            text: text,
            hide: hide,
            show: show,
            hideAll: hideAll,
            widget: widget,
            option: options,
            config: param,
            init: init
        };
        //用于option方法的设置参数
        var param = module.config = $.extend(true,{}, config, ui.config.dropdown, option );

        
        var id ,
            $id,
            $menu,
            //是否使用相对定位,相对定位没有定义宽度的话是继承父层的宽度,如果
            winWidth = document.documentElement.clientWidth,
            direction,
            relative,
            submenuWidth,
            $submenu;
        
        //执行初始化
        init(param);

        //初始化
        function init (option) {
            option = option || param;
            
            if( option.id ){
                $id = ui.obj(option.id);
            }else{
                ui.hint("dropdown id不能为空");
                return;
            }

            //option获取新参数使用
            param = module.config = option;
            $menu = $id.children( option.handle ) ;
            $submenu = option.target ? $id.children( option.target ): $menu.next();
            relative = option.relative;

            //下拉菜单的方向
            direction = $id.attr("position") || option.position ;

            var offsetLeft = $id.offset() && $id.offset().left || 0,
                left = option.width ? "auto": -offsetLeft+"px",
                position = {
                    "bottom": {
                        menuPosition: "bui-menu-bottom",
                        arrowPosition: "bui-arrow-up",
                        left: left
                    },
                    "top": {
                        menuPosition: "bui-menu-top",
                        arrowPosition: "bui-arrow-down",
                        left: left
                    },
                    "left": {
                        menuPosition: "bui-menu-left",
                        arrowPosition: "bui-arrow-right",
                        left: "auto"
                    },
                    "right": {
                        menuPosition: "bui-menu-right",
                        arrowPosition: "bui-arrow-left",
                        left: "100%"
                    }
                }

            //二级菜单需要定宽,如果是上下,显示屏幕宽度,左右继承父层的宽度
            submenuWidth = option.width > 0 ? option.width: (relative  ? winWidth: option.width );

            //初始化二级菜单的宽度及隐藏状态
            if( parseFloat(submenuWidth) > 0 ){
                $submenu.width( submenuWidth );
            };

            var className = option.showArrow ? position[direction]["menuPosition"] + ' ' +position[direction]["arrowPosition"]: position[direction]["menuPosition"];
            // 修正菜单左边位置
                fixmenu(className,position[direction]["left"]);

            //设置已经选择的二级菜单
            var $active = $submenu.find(".active").eq(0);
            if( $active.length > 0 ){
                var title = $.trim($active.text()),
                    val = $active.attr("value") || "";
                //设置并且隐藏菜单
                text(title);
                value(val);
                hide();

                !option.showActive && $submenu.find(option.targetHandle).removeClass("active");
            }

            //一级菜单
            $menu.off('click.bui').on('click.bui',function (e) {

                var isActive = $(this).hasClass('active');

                //隐藏所有二级菜单;
                hideAll();
                if( isActive ){
                    hide();
                }else{
                    show();
                }

                e.stopPropagation();
            })

            // 二级菜单
            $submenu.off('click.bui').on('click.bui',option.targetHandle,function (e) {

                var val = $(this).attr("value") || "",
                    title = $.trim($(this).text());

                //是否修改选中以后的文本值
                var change = $id.attr("change") != undefined ? $id.attr("change"): option.change ;

                //显示选中的状态
                if( option.showActive ){
                    $(this).addClass("active")
                        .siblings().removeClass('active');
                }
                //是否改变文本值
                if( change == true ){

                    text( title );
                }

                value( val );

                //隐藏菜单
                hide();

                option.callback && option.callback.call(this,module,title,val);

                // 导致btn控件无法跳转页面
                // e.stopPropagation();

            });
           
           $("body").off("click.bui").on("click.bui",function (e) {
               hideAll();
               e.stopPropagation();
           })

           return this;
            
        }

        //修正菜单
        function fixmenu (classname,value) {

            $submenu.addClass( classname );
            if( relative  ){
                $submenu.css({
                    left: value
                })
            }
        }
        /**
         * 设置或者获取值
         *  @method value
         *  @param {string} [text] [设置的值]
         *  @example 
            
            //设置值
            uiDropdown.value("10");

            //获取值
            var val = uiDropdown.value();
                
         */
        function value (text) {

            if( text ){

                $menu.attr("value",text)

            }else{
                var value = $menu.attr("value");
                return value;
            }
            
        }

        /**
         * 设置或者获取文本
         *  @method text
         *  @param {string} [text] [设置文本]
         *  @example 
            
            //设置文本
            uiDropdown.text("广东省");

            //获取文本
            var val = uiDropdown.text();
                
         */
        function text (text) {
            var val = val || "";

            if( text ){
                
                var $span1 = $menu.children(param.handleChildren);
                if( $span1 ){
                    $span1.text(text);
                }else{
                    $menu.text(text);
                }
            }else{
                var value = $.trim( $menu.text() );
                return value;
            }
        }

        /**
         * 隐藏二级菜单
         *  @method hide
         *  @example 
            
            //隐藏二级菜单
            uiDropdown.hide();
                
         */
        function hide() {
             $menu.removeClass("active");
             $submenu.css("display","none");
        }
        /**
         * 显示二级菜单
         *  @method show
         *  @example 
            
            //显示二级菜单
            uiDropdown.show();
                
         */
        function show() {
             $menu.addClass("active");
             $submenu.css("display","block");
        }

         /**
         * 隐藏所有二级菜单
         *  @method hideAll
         *  @example 
            
            //显示二级菜单
            uiDropdown.hideAll();
                
         */
        function hideAll() {
             $(".bui-dropdown > .bui-btn").removeClass("active");
             $(".bui-dropdown > .bui-list").css("display","none");
        }
        /**
         * 获取依赖的控件
         *  @method widget
         *  @param {string} [name] [ 依赖控件名 ]
         *  @example 
            
            //获取依赖控件
            var uiDropdownWidget = uiDropdown.widget();
            
                
         */
        function widget(name) {
            var control = {};
            return ui.widget.call(control,name);
        };
        /**
         * 获取设置参数
         *  @method option
         *  @param { string | object } [key] [ 不传则获取所有参数, 类型为string,没有第2个参数则获取某个参数 ]
         *  @param { string | number | boolean | function } [value] [ 设置参数的时候要传,设置多个参数不用传,获取参数的时候也不用传 ]
         *  @chainable
         *  @example 
            
            
            //获取所有参数
            var option = uiDropdown.option();

            //获取某个参数
            var id = uiDropdown.option( "id" );

            //修改一个参数
            uiDropdown.option( "width",200 );

            //修改多个参数
            uiDropdown.option( {"width":200} );
                
         */
        function options (key,value) {

           return ui.option.call(module,key,value);
        }

        return module;

    };

    return ui;

})( bui || {} );
